<div class="dialog-title-bar">
  <h2 mat-dialog-title>Rock File Preview</h2>
  <button mat-icon-button class="close-button" (click)="onClose()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="preview-container">
    <div class="file-name">
      <strong>{{ data.fileName | removeExtension }}</strong>
    </div>

    <div class="image-wrapper">
      @if (!isLoading && !hasError && thumbnailUrl) {
        <div class="porosity">
          <span class="porosity-label">Porosity:</span>
          <span class="porosity-value">{{ totalPorosity }}</span>
        </div>
      }

      <div class="thumbnail-container">
        @if (isLoading) {
          <div class="loading-state">
            <mat-spinner diameter="50"></mat-spinner>
            <p>Loading thumbnail...</p>
          </div>
        } @else if (hasError || !thumbnailUrl) {
          <div class="error-state">
            <mat-icon>image_not_supported</mat-icon>
            <p>Thumbnail not available</p>
          </div>
        } @else {
          <img [src]="thumbnailUrl" [alt]="data.fileName" class="thumbnail-image" />
        }
      </div>

      @if (!isLoading && !hasError && thumbnailUrl) {
        <div class="legend">
          <div class="legend-item">
            <div class="legend-square pore"></div>
            <span>Pore</span>
          </div>
          <div class="legend-item">
            <div class="legend-square rock"></div>
            <span>Rock</span>
          </div>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
